'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SectionImage = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n    max-width: 100%;\n    align-self: end;\n    justify-self: center;\n'], ['\n    display: block;\n    max-width: 100%;\n    align-self: end;\n    justify-self: center;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _LazyImg = require('./LazyImg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SectionImage = exports.SectionImage = (0, _styledComponents2.default)(_LazyImg.LazyImg)(_templateObject);
SectionImage.displayName = 'SectionImage';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/SectionImage.js
// module id = 129
// module chunks = 0